module.exports = __webpack_public_path__ + "static/media/vibrateMode.d86aad57.svg";